import styled, { css } from 'styled-components';
import theme from '../../theme';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 10px;
  margin-bottom: 70px;
  width: 100%;
  max-width: 600px;
`;

const Carousel = styled.div`
  text-align: center;
  overflow: hidden;
  width: 100%;

  span + span {
    margin-left: 10px;
  }
`;

const Items = styled.div<{
  $length: number;
}>`
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  ${props => props.$length < 3 && css`
    align-items: center;
    justify-content: center; 
  `}

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

const Item = styled.div<{
  $active?: boolean;
  $first?: boolean;
  $last?: boolean;
}>`
    flex-shrink: 0;
    width: calc((100% - 20px) / 3);
    height: 100%;
    height: 200px;
    padding: 10px 0;
    border-radius: 10px;
    background-color: white;
    opacity: ${props => props.$active ? 1 : 0.5};
    box-shadow: ${props => props.$active ? '0px 9px 15px rgba(0, 0, 0, 0.2)' : 'none'};
    transform-origin: center center;
    transform: scale(1);
    transition: transform 0.5s;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    margin-bottom: 18px;
    margin-top: 10px;
    margin-left: 10px;
    ${props => props.$last && css`
      margin-right: 20px;
    `};
    ${props => props.$active && css`
      height: 220px;
      margin-top: 0;
    `};
`;

const ItemShortcut = styled.span<{
  $active?: boolean;
}>`
    display: inline-flex;
    width: 14px;
    height: 14px;
    text-decoration: none;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin: 0 0 0.5rem 0;
    position: relative;
    background-color: #ccc;
    cursor: pointer;

  ${props => props.$active && css`
    background-color: ${theme.primaryColor};
    cursor: auto;
  `}

`;

export { Container, Carousel, Items, Item, ItemShortcut };